// client/src/services/callHistoryService.js

import { fetchWithAuth } from './apiClient';

const ITEMS_PER_PAGE = 10;

const getApiUrl = () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL;
  return window.location.hostname === 'localhost'
    ? 'http://localhost:7080/api'
    : `/api`;
};

export const callHistoryService = {

  async fetchCallHistory(username, page = 1) {
    const skip = (page - 1) * ITEMS_PER_PAGE;
    const apiUrl = `${getApiUrl()}/call-history/`;

    console.log(`📄 Fetching page ${page} data (skip: ${skip}, limit: ${ITEMS_PER_PAGE})`);

    // fetchWithAuth auto-attaches token and handles 401/403
    const response = await fetchWithAuth(
      `${apiUrl}${username}?limit=${ITEMS_PER_PAGE}&skip=${skip}`
    );

    const data = await response.json();
    return data;
  },

  async logout() {
    const apiUrl = `${getApiUrl()}/logout`;

    try {
      await fetch(apiUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (error) {
      console.error('Logout API error:', error);
    }
  },

  ITEMS_PER_PAGE
};